import {lazyRegister} from '@/Core/lazyRegister';
import './page-container.component.css';
import template from './page-container.component.html';
import '@components/Forms/container/sidebar/sidebar.component';

class PageContainerController {
    static $inject = [
        '$element',
        '$transclude'
    ];

    private hasTitle: boolean;
    private hasControls: boolean;
    private hasFooter: boolean;
    private hasSidebar: boolean;
    private hasSidebarHeader: boolean;
    private hasSidebarFooter: boolean;
    private hasContentHeader: boolean;

    constructor(private $element,
                private $transclude: ng.ITranscludeFunction) {
    }

    $onInit(): void {
        this.$element.addClass('page-container');

        this.hasTitle = this.$transclude.isSlotFilled('title') ?? false;
        this.hasControls = this.$transclude.isSlotFilled('controls') ?? false;
        this.hasFooter = this.$transclude.isSlotFilled('footer') ?? false;
        this.hasSidebar = this.$transclude.isSlotFilled('sidebarBody') ?? false;
        this.hasSidebarHeader = this.$transclude.isSlotFilled('sidebarHeader') ?? false;
        this.hasSidebarFooter = this.$transclude.isSlotFilled('sidebarFooter') ?? false;
        this.hasContentHeader = this.$transclude.isSlotFilled('contentHeader') ?? false;
    }
}

export const PageContainerComponent: ng.IComponentOptions = {
    transclude: {
        title: '?pageTitle',
        controls: '?pageControls',
        sidebarHeader: '?sidebarHeader',
        sidebarBody: '?sidebarBody',
        sidebarFooter: '?sidebarFooter',
        contentHeader: '?pageContentHeader',
        content: 'pageContent',
        footer: '?pageFooter',
    },
    bindings: {},
    template: template,
    controller: PageContainerController
};

lazyRegister.component('pageContainer', PageContainerComponent);